var React = require('react');

function ModeDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M479.9-111.52q-153.49 0-260.93-107.45Q111.52-326.41 111.52-479.9t107.47-261.32Q326.47-849.04 480-849.04q12.3 0 24.67.71 12.37.72 24.24 2.72-34.21 31.26-55.04 74.65t-20.83 92.87q0 94.01 66.14 159.81 66.13 65.8 160.6 65.8 49.35 0 92.52-20.54 43.18-20.55 73.87-54.76 1.44 11.87 2.16 23.51.71 11.63.71 23.7 0 153.4-107.82 261.22Q633.39-111.52 479.9-111.52Zm.1-106q73.3 0 134.26-37.2 60.96-37.19 93.52-98.8-14.35 2.74-28.69 4.04-14.35 1.31-28.13.18-120.74-9.61-205.83-93.29-85.09-83.67-95.83-208.93-.56-13.78.46-28.13t4.33-28.13q-61.05 33.13-98.81 94.09-37.76 60.95-37.76 133.69 0 108.74 76.87 185.61 76.87 76.87 185.61 76.87Zm-17.35-245.13Z"}));
}

ModeDark.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = ModeDark;

ModeDark.default = ModeDark;
